export const SITE_URL = "https://saarthva.com";
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const breadcrumb = (name, path) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
    { "@type": "ListItem", position: 2, name, item: `${SITE_URL}${path}` },
  ],
});

export const serviceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE_URL}${path}`,
  provider: { "@type": "Organization", name: "Saarthva Ventures", url: `${SITE_URL}/` },
  areaServed: { "@type": "Country", name: "India" },
});
